// extracted by mini-css-extract-plugin
export default {"license":"licenseWindow_license__hnGpt"};